import '@babel/polyfill';
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import { router } from './router';
import { store } from './store';
import './styling/main.less';
import './filters';
import './ui/shared/image/onerror.directive';
import './ui/shared/in-viewport.directive';
import './ui/shared/fully-in-viewport.directive';
import './ui/shared/submit.directive';
import './main.config';
import './main.plugins';
import './enums';
sync(store, router);


Vue.mixin({
    mounted() {
    // Only add to root element of SFCs (not functional or abstract)
        if (this.$el && this.$options.__file && this.$el.setAttribute) {
            // __file is the full path, so just use the filename
            this.$el.setAttribute(
                'data-source',
                this.$options.__file.split(/[\\/]/).pop()
            );
        }
    },
});

// tslint:disable-next-line:no-unused-expression
new Vue({
    el: '#lpapp',
    router,
    store,
});
